import {ApolloClient, DefaultOptions, InMemoryCache, createHttpLink} from "@apollo/client";
import getAPIKey from "./getAPIKey";
import getListingSettings from "./getListingSettings";

const key = getAPIKey();
const settings = getListingSettings();
const cache = new InMemoryCache();
const endpoint = createHttpLink({
    uri: settings.host,
    headers: {
        authorization: `Bearer ${key}`
    }
})


const client = new ApolloClient({
    link: endpoint,
    cache: cache,
});

export default client;
